import React from 'react';
import cn from 'classnames';

import Typography from '@components/typography';
import { useDeviceDetect } from '@hooks/usedevicedetect';

import '@styles/customise/option.scss';

interface OptionsHeaderProps {
  currentStep: number;
  totalSteps: number;
  title: string;
  showWarning?: boolean;
  className?: string;
}

const Header: React.FC<OptionsHeaderProps> = ({
  currentStep,
  totalSteps,
  title,
  showWarning = false,
  className,
}) => {
  const { isMobile } = useDeviceDetect();

  return (
    <header
      className={cn(
        'customise-options__header',
        className ? className : '',
        isMobile ? 'option-header-mobile' : ''
      )}
      data-testid="option-header"
      data-cy="option-header"
    >
      {isMobile && (
        <Typography
          className="customise-options__step-indicator"
          variant="caption"
          size="sm"
        >{`Step ${currentStep} of ${totalSteps}`}</Typography>
      )}
      <div className="customise-options__header--text">
        <Typography
          className="header-label"
          variant="h2"
          size="2x"
          weight="bold"
        >
          {title}
        </Typography>
        {showWarning ? (
          <span>
            <Typography className="header-asterisk" variant="caption" size="sm">
              {'*'}
            </Typography>
            <Typography className="header-warning" variant="caption" size="sm">
              {`You have to select one ${title}`}
            </Typography>
          </span>
        ) : null}
      </div>
    </header>
  );
};

export default Header;
